import './mask-field-boolean.scss'

import { PropType } from "vue"
import Component from 'vue-class-component'
import _ from 'lodash';

import { EntityField, EntityFieldStatus } from '@skinsoft/types';

import { ReactiveVue } from '@skinsoft/reactive-vue';

@Component({
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
        },
        fieldValue: {},
        editing: {
            type: Boolean,
        },
        getStatus: {},
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-boolean.html')
})
export class MaskFieldBoolean extends ReactiveVue {
    private entityField: EntityField
    private fieldValue: any
    private editing: Boolean
    private dataCy: String
    private getStatus: (entityField: EntityField) => EntityFieldStatus

    private get value(): Boolean {
        return this.fieldValue
    }

    private set value(input: Boolean) {
        this.$emit("value-change", {
            abstractEntity: this.entityField.abstractEntity,
            fieldPath: this.entityField.path,
            value: input,
        })
    }

    private isReadonly(entityField: EntityField) {
        return entityField.isReadOnly || this.getStatus(entityField).disabled
    }

    private infoMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).disabledMessage
    }

    private errorMessage(entityField: EntityField): string | undefined {
        return this.getStatus(entityField).errorMessage
    }

    private hasError(entityField: EntityField) {
        return this.getStatus(entityField).error
    }
}